import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import InternalPicturematerial from './picture/internal-picture'
import Picturematerial from './picture/picture'
import Videomaterial from './picture/video'

const path = '/main/material'

export const PICTURE_MATERIAL_PATH = path + '/picture'
export const INTERNAL_PICTURE_MATERIAL_PATH = path + '/internalPicture'
export const VIDEO_MATERIAL_PATH = path + '/video'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/picture'} component={Picturematerial}></Route>
            <Route path={props.match.path + '/internalPicture'} component={InternalPicturematerial}></Route>
            <Route path={props.match.path + '/video'} component={Videomaterial}></Route>
        </Switch>
    )
}
